import img from "../img/nft/main1.png";
import img2 from "../img/nft/main2.png";
import img3 from "../img/nft/main3.png";
import thumb1 from "../img/nft/t1.png";
import thumb2 from "../img/nft/t2.png";
import thumb3 from "../img/nft/t3.png";
import thumb4 from "../img/nft/t4.png";
import thumb5 from "../img/nft/t5.png";
import thumb6 from "../img/nft/t6.png";
import thumbnail from "../img/nft/thumbnail.png";
import tokenIcon from "../img/token-icon.png";

const data = [
	{
		tokenName: "Antexpad 1",
		logo: tokenIcon,
		staus: "live",
		audit: true,
		kyc: true,
		chain: "bsc",
		liquidityLock: "60%",
		userWhitelist: 8,
		totalWhitelist: 400,
		reservedUsers: 5,
		totalReservations: 200,
		softcap: 20_000,
		hardcap: 40_000,
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		round: "Round 1",
		countDown: "2023:12:31:23:59:59",
		totalSold: 22_000,
		progressBAr: (22_000 / 40_000) * 100,
	},
	{
		tokenName: "Antexpad 2",
		logo: tokenIcon,
		staus: "live",
		audit: false,
		kyc: false,
		chain: "hepton",
		liquidityLock: "60%",
		userWhitelist: 8,
		totalWhitelist: 400,
		reservedUsers: 5,
		totalReservations: 200,
		softcap: 20_000,
		hardcap: 40_000,
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		round: "Round 1",
		countDown: "2023:12:31:23:59:59",
		totalSold: 12_000,
		progressBAr: (12_000 / 40_000) * 100,
	},
	{
		tokenName: "Antexpad 3",
		logo: tokenIcon,
		staus: "upcoming",
		audit: false,
		kyc: false,
		chain: "bsc",
		liquidityLock: "60%",
		userWhitelist: 8,
		totalWhitelist: 400,
		reservedUsers: 5,
		totalReservations: 200,
		softcap: 20_000,
		hardcap: 40_000,
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		round: "Round 1",
		countDown: "2023:12:31:23:59:59",
		totalSold: 0,
		progressBAr: (0 / 40_000) * 100,
	},
	{
		tokenName: "Antexpad 1",
		logo: tokenIcon,
		staus: "live",
		audit: true,
		kyc: true,
		chain: "bsc",
		liquidityLock: "60%",
		userWhitelist: 8,
		totalWhitelist: 400,
		reservedUsers: 5,
		totalReservations: 200,
		softcap: 20_000,
		hardcap: 40_000,
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		round: "Round 1",
		countDown: "2023:12:31:23:59:59",
		totalSold: 22_000,
		progressBAr: (22_000 / 40_000) * 100,
	},
	{
		tokenName: "Antexpad 2",
		logo: tokenIcon,
		staus: "live",
		audit: false,
		kyc: false,
		chain: "hepton",
		liquidityLock: "60%",
		userWhitelist: 8,
		totalWhitelist: 400,
		reservedUsers: 5,
		totalReservations: 200,
		softcap: 20_000,
		hardcap: 40_000,
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		round: "Round 1",
		countDown: "2023:12:31:23:59:59",
		totalSold: 12_000,
		progressBAr: (12_000 / 40_000) * 100,
	},
	{
		tokenName: "Antexpad 3",
		logo: tokenIcon,
		staus: "upcoming",
		audit: false,
		kyc: false,
		chain: "bsc",
		liquidityLock: "60%",
		userWhitelist: 8,
		totalWhitelist: 400,
		reservedUsers: 5,
		totalReservations: 200,
		softcap: 20_000,
		hardcap: 40_000,
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		round: "Round 1",
		countDown: "2023:12:31:23:59:59",
		totalSold: 0,
		progressBAr: (0 / 40_000) * 100,
	},
];

const nfts = [
	{
		NFTname: "Super rarible",
		img: img,
		img2: thumb1,
		img3: thumb2,
		staus: "upcoming",
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		floorPrice: 0.1,
		totalSupply: 1000,
		// thumbnail
		thumbnail: thumbnail,
	},
	{
		NFTname: "Super rarible",
		img: img2,
		img2: thumb3,
		img3: thumb4,
		staus: "live",
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		floorPrice: 0.1,
		totalSupply: 1000,
		// thumbnail
		thumbnail: thumbnail,
		verified: true,
	},
	{
		NFTname: "Super rarible",
		img: img3,
		img2: thumb5,
		img3: thumb6,
		staus: "uocinubg",
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		floorPrice: 0.1,
		totalSupply: 1000,
		// thumbnail
		thumbnail: thumbnail,
	},
	{
		NFTname: "Super rarible",
		img: img,
		img2: thumb1,
		img3: thumb2,
		staus: "upcoming",
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		floorPrice: 0.1,
		totalSupply: 1000,
		// thumbnail
		thumbnail: thumbnail,
		verified: true,
	},
	{
		NFTname: "Super rarible",
		img: img2,
		img2: thumb3,
		img3: thumb4,
		staus: "live",
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		floorPrice: 0.1,
		totalSupply: 1000,
		// thumbnail
		thumbnail: thumbnail,
	},
	{
		NFTname: "Super rarible",
		img: img3,
		img2: thumb5,
		img3: thumb6,
		staus: "upcoming",
		description:
			"Antex Provides an innovative platform for Hepton l2 blockchains website and software",
		floorPrice: 0.1,
		totalSupply: 1000,
		// thumbnail
		thumbnail: thumbnail,
	},
];
export { nfts, data };
